import { BEIGE_300, GRAY_700, GRAY_900, RhetorikFontFamily } from 'constants/styling/theme'
import { Box, Stack, Typography } from '@mui/material'
import { FC, useMemo } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { BKBNThemeWrapper } from 'components/common/BKBNThemeWrapper'
import { EmailVerifyMode } from '../EmailVerified/EmailVerified'
import { useAuth0 } from 'utils/auth'
import { useResendChangeEmail } from 'dataQueries'

interface Props {
  handleResendEmail: () => void
}

/**
 * Displays custom Verify Email component during onboarding flow.
 * 
 * @example <OnboardingPageVerifyEmail />
 */
export const OnboardingPageVerifyEmail: FC<Props> = ({ handleResendEmail }) => {
  const { t } = useTranslation(['unverified_user'])
  const { user } = useAuth0()
  const resendChangeEmail = useResendChangeEmail()

  const rawSearch = (typeof window !== 'undefined' && window.location.search) || ''
  const params = new URLSearchParams(rawSearch)
  const modeParam = params.get('mode')
  const newEmailParam = params.get('email')

  const isChangeEmail = useMemo(() => modeParam === EmailVerifyMode.CHANGE_EMAIL, [modeParam])
  const emailToShow = useMemo(() => {
    if (isChangeEmail && newEmailParam) {
      return newEmailParam
    }
    return user?.email || ''
  }, [isChangeEmail, newEmailParam, user?.email])

  return (
    <BKBNThemeWrapper>
      <Box sx={{ width: '100%', height: '100vh', display: 'flex', backgroundColor: BEIGE_300 }}>
        <Stack direction="column" gap={2} alignItems="center" textAlign="center" margin='24rem auto' width='36rem'>

          <Typography fontSize='3rem' fontFamily={RhetorikFontFamily} color={GRAY_900}>{t('verify_email_title')}</Typography>

          <Typography variant='text-sm' color={GRAY_700} >

            <Trans t={t} i18nKey="verify_email_description_top" values={{ email: emailToShow }}>
              <Typography variant='text-sm' fontWeight={600} color={GRAY_900}></Typography>
            </Trans>

            <Stack marginTop='1.2rem'>
              <Trans t={t} i18nKey="verify_email_description_bottom">
                <Typography
                  sx={{ cursor: 'pointer' }}
                  variant='text-sm'
                  fontWeight={600}
                  color={GRAY_900}
                  onClick={!resendChangeEmail.isPending ? handleResendEmail : undefined}
                />
              </Trans>
            </Stack>

          </Typography>

        </Stack>
      </Box>
    </BKBNThemeWrapper>
  )
}
